import { render, staticRenderFns } from "./giftStoreDetail.vue?vue&type=template&id=d08cd522"
import script from "./giftStoreDetail.vue?vue&type=script&lang=js"
export * from "./giftStoreDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports